<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">
                <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" @click.prevent="signOut" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 bgsecond mt-2 text-light">

                <div class="row mb-2">
                    <h1 class="col-md-12 text-center">Branches</h1>
                </div>

                <div class="row  mt-2">

                    <div class="col-md-2 " v-if="authenticatedUser.permissions.includes('super') ">
                        <b-link class="" :to="{ path: '/branch-form',query: { type: 'add'} }">
                            <b-button class="btn-info mb-2" > Add Branch </b-button>
                        </b-link>
                    </div>

                    <div class="col-md-2" v-if="authenticatedUser.permissions.includes('super')">
                        <b-input v-model="searchName"
                                 @input="debouncedSearch"
                                 placeholder="Search by Name"></b-input>
                    </div>

                </div>
                <div class="row mt-2" >
                    <div class="col-md-2">
                    </div>
                    <div class="col-md-2">

                    </div>
                    <div class="col-md-1">
                        <button class="btn-sm btn-info"     :disabled="branches?.current_page==1" @click="get_paged_data('prev')">Previous</button>
                    </div>
                    <div class="col-md-3">
                        <span class="text-light mx-2 px-2" v-if="!showloader" style="border: 3px solid white; border-radius: 5px"> showing  ( <span v-if="branches?.to-50>0">{{branches?.to-50}}</span> <span v-else="">0</span>  to {{branches.to}}) out of {{branches.total}} records</span>
                    </div>
                    <div class="col-md-1">

                        <button class="btn-sm btn-info "    :disabled="branches?.current_page==totalPages" @click="get_paged_data('next')">Next</button>
                    </div>
                    <div class="col-md-2 ">

                    </div>

                </div>
                <div class="row mt-1">
                    <div v-if="showloader" class="col-md-10 offset-1 text-center">
                        <loader/>
                    </div>
                </div>
                <div class="row mt-2">
                 <div class="col-md-12">
                     <table class="table table-bordered table-striped text-light">
                         <thead class="thead-dark">
                         <tr>

                             <th>ID</th>
                             <th>Name</th>
                             <th>Short Code</th>
                             <th>Address Line 1</th>
                             <th>State</th>
                             <th>Postcode</th>
                             <th>Tel</th>
                             <th>Email</th>
                             <th class="text-center">Actions</th>
                         </tr>
                         </thead>
                         <tbody >
                         <template v-for="branch in branches.data">
                             <tr>
                                 <td>{{branch.id}}</td>
                                 <td>{{branch.name}}</td>
                                 <td>{{branch.short_code}}</td>
                                 <td>{{branch.addressLine1}}</td>
                                 <td>{{branch.state}}</td>
                                 <td>{{branch.postcode}}</td>
                                 <td>{{branch.tel}}</td>
                                 <td>{{branch.email}}</td>
                                 <td class="text-center">
                                     <b-link class="mx-1" :to="{ path: '/branch-form',query: { type: 'edit', 'id': branch.id } }">
                                         <b-button class="btn-info  mb-1" > Edit </b-button>
                                     </b-link>
<!--                                     <b-button @click="deleteBranch(branch.id)" :disabled="saving" class="btn-danger "> Delete </b-button>-->
                                 </td>
                             </tr>
                         </template>

                         </tbody>
                     </table>
                 </div>
                </div>

            </div>

        </div>

    </div>

</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from 'vuex';
import { mapState } from 'vuex';
import sidebar from "@/components/layout/sidebar";
import showrealtime from "@/components/showrealtime";
import Welcomenote from "@/pages/admin/mypos/welcomenote.vue";
import URL from "@/constants/baseurl";
import Loader from "@/components/loader.vue";
import Swal from "sweetalert2";
import axios from "axios";
import {cloneDeep} from "lodash";
import debounce from "lodash/debounce";


export default {
    name: "branch management",

    components:{Loader, Welcomenote, 'sidebar': sidebar,'ShowRealTime':showrealtime},
    computed: {
        ...mapGetters(['AuthenticatedUser']),

        ...mapState('branches',['branch_filters','branches']),
        totalPages() {
            const perpage = this.branches.per_page;
            const total=this.branches.total;

            return Math.ceil(total / perpage);
        },
        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },


    },
    data() {
        return {
            saving:false,
            showloader:false,
            searchName:'',
        };
    },
    async created() {
        this.searchName = this.branch_filters.name;
        this.showloader=true
        await this.get_branches();
        this.showloader=false

    },
    async mounted() {

    },
    methods: {
        ...mapActions(['login', 'processLogoutManual']),
        ...mapActions('branches', ['set_branches','get_branches']),

        debouncedSearch: debounce(function () {
            this.branch_filters.name = this.searchName;
            this.branch_filters.page = 1;
            this.showloader = true;
            this.get_branches().finally(() => {
                this.showloader = false;
            });
        }, 500),

        async deleteBranch(id){

            const result = await Swal.fire({
                title: 'Are you sure you want to delete this branch?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            });
            if (result.isConfirmed) {

                const apiToken = localStorage.getItem('token');
                if (apiToken) {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
                }
                try {
                    this.saving=true
                    const res = await axios.delete(`${URL.BASEURL}/api/delete-branch/${id}`);

                    if (res) {
                        let branches=cloneDeep(this.branches)
                        branches.data=this.branches.data.filter((c)=>c.id!==id)
                        await this.set_branches(branches)

                        Swal.fire('success', 'Branch Deleted', 'success');

                    } else {
                        Swal.fire('info', 'Branch Cannot Be Deleted', 'info');
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire('Error', 'Failed to delete branch.', 'info');
                }
                this.saving=false
            }

        },

        async signOut() {
            await this.processLogoutManual();
            window.location.href = this.$router.resolve({ name: "Login" }).href;
        },

        async get_paged_data(button){
            let current_page= this.branches.current_page
            this.branch_filters.page=current_page

            if(button=='next'){
                this.branch_filters.page=current_page+1
                await this.get_branches()
            }
            if(button=='prev'){
                this.branch_filters.page=current_page-1
                await this.get_branches()
            }
        },

    },
}
</script>

<style scoped>
@import '../../../assets/styles/pos.css';
.hide {
    visibility: hidden !important;
}

</style>
